export enum HTTPResponses {
  OK,
  KO,
  EXPIRED,
  USED,
  NOT_FOUND,
  INVALID,
  UNAUTH,
  ALREADY_PRESENT
}
